import { Map } from 'immutable';
import { connect, dismissGradeByQuestionBanner, postToParent, getResultInfo, newActiveQuizSession, postQuizSessionResults, changeFudgePoints, sessionItemResultsModification, addSuccess as successNotification, screenreaderNotification, set, QuizSession, QuizSessionResult, SessionItemResult, getActiveQuiz, getGradingSessionItems, getGradingSessionItemResults, setGradeByQuestionEnabled } from '@instructure/quiz-core';
import { Grading as GradingPresenter } from './presenter';
var cachedQuizSessionId = null;
var cachedScope = function cachedScope() {};
export var mapStateToProps = function mapStateToProps(state, ownProps) {
  var quizSessionId = ownProps.quizSessionId;

  // We try to cache the scope function in order to not trick Redux into thinking something
  // has changed on the component whenever state changes.
  if (cachedQuizSessionId !== quizSessionId) {
    cachedQuizSessionId = quizSessionId;
    cachedScope = function cachedScope(record) {
      return record.get('quizSessionId') === cachedQuizSessionId;
    };
  }
  var quizSession = QuizSession.create(state.getIn(['quizSessions', quizSessionId]));
  var qsrId = quizSession.authoritativeResult;
  var authoritativeResult = QuizSessionResult.create(state.getIn(['quizSessionResults', qsrId]));
  var sessionItems = getGradingSessionItems(state.get('sessionItems', Map()), cachedScope);
  var sessionItemResults = getGradingSessionItemResults(state.get('sessionItemResults', Map()), cachedScope);
  var needToLoad = !authoritativeResult.isGraded() || !authoritativeResult.isLoaded() || !quizSession.isLoaded() || sessionItems.size === 0 || sessionItemResults.size === 0;
  var hasSessionItemResultsMods = sessionItemResults.some(function (sessionItemResult) {
    return SessionItemResult.create(sessionItemResult).hasModifications();
  });
  return {
    gradeByQuestionEnabled: state.getIn(['grading', 'gradeByQuestionEnabled']),
    hasResultsModifications: hasSessionItemResultsMods || authoritativeResult.hasModifications(),
    gradeByQuestionBannerDismissed: state.getIn(['grading', 'gradeByQuestionBannerDismissed']),
    needToLoad: needToLoad,
    quiz: getActiveQuiz(state),
    quizSessionResult: authoritativeResult,
    regradingIdentifier: state.getIn(['regrading', 'regradeEditModeKey'], ''),
    sessionItems: sessionItems,
    updatingGrade: state.getIn(['ui', 'updatingGrade'], false),
    workingQuizSessionResult: authoritativeResult.getWorkingInstance()
  };
};
var actionProps = {
  changeFudgePoints: changeFudgePoints,
  dismissGradeByQuestionBanner: dismissGradeByQuestionBanner,
  fetchQuizSession: getResultInfo,
  newActiveQuizSession: newActiveQuizSession,
  postQuizSessionResults: postQuizSessionResults,
  postToParent: postToParent,
  screenreaderNotification: screenreaderNotification,
  sessionItemResultsModification: sessionItemResultsModification,
  setGradeByQuestionEnabled: setGradeByQuestionEnabled,
  setUpdatingGrade: function setUpdatingGrade(bool) {
    return set('updatingGrade', bool);
  },
  successNotification: successNotification,
  windowObj: window
};
export var Grading = connect(mapStateToProps, actionProps)(GradingPresenter);
export default Grading;